import React, { useState } from 'react';
import { Container, Button } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import UiContent from '../../Components/Common/UiContent';
import PersonalProtectiveEquipmentMotionList from './PersonalProtectiveEquipmentMotionList';

const PersonalProtectiveEquipmentMotion = () => {
	const today = new Date();
	const [month, setMonth] = useState(today.getMonth() + 1); // 1-12
	const [year, setYear] = useState(today.getFullYear());

	const monthNames = [
		'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
		'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
	];

	const handleChangeMonth = (direction) => {
		let newMonth = month + direction;
		let newYear = year;

		if (newMonth > 12) {
			newMonth = 1;
			newYear++;
		} else if (newMonth < 1) {
			newMonth = 12;
			newYear--;
		}

		setMonth(newMonth);
		setYear(newYear);
	};

	const title = `Movimiento de EPP de ${monthNames[month - 1]} del ${year}`;
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Abastecimiento', icon: 'icon-shopping-basket' },
		{ to: '#', label: 'Gestión de EPP', icon: 'icon-shirt' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className="page-content">
				<Container fluid>



					<BreadCrumb
						title={title}
						links={breadcrumbLinks}
						controls={{
							prev: <Button className='btn btn-icon' size="sm" color="primary" onClick={() => handleChangeMonth(-1)}><i class="ri-arrow-drop-left-line fs-20"></i></Button>,
							next: <Button className='btn btn-icon' size="sm" color="primary" onClick={() => handleChangeMonth(1)}><i class="ri-arrow-drop-right-line fs-20"></i></Button>,
						}}
						icon={'icon-archive'}
					/>


					<PersonalProtectiveEquipmentMotionList month={month} year={year} />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default PersonalProtectiveEquipmentMotion;
